<!--
 *                   ___====-_  _-====___
 *             _--^^^#####//      \\#####^^^--_
 *          _-^##########// (    ) \\##########^-_
 *         -############//  |\^^/|  \\############-
 *       _/############//   (@::@)   \############\_
 *      /#############((     \\//     ))#############\
 *     -###############\\    (oo)    //###############-
 *    -#################\\  / VV \  //#################-
 *   -###################\\/      \//###################-
 *  _#/|##########/\######(   /\   )######/\##########|\#_
 *  |/ |#/\#/\#/\/  \#/\##\  |  |  /##/\#/  \/\#/\#/\#| \|
 *  `  |/  V  V  `   V  \#\| |  | |/#/  V   '  V  V  \|  '
 *     `   `  `      `   / | |  | | \   '      '  '   '
 *                      (  | |  | |  )
 *                     __\ | |  | | /__
 *                    (vvv(VVV)(VVV)vvv)
 * 
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *                神兽保佑            永无BUG
 * 
 * @Author: 路守恒
 * @LastEditors: 路守恒
 * @Date: 2021-12-30 16:56:07
 * @LastEditTime: 2021-12-30 18:05:17
 * @FilePath: \news2021\src\components\xgplayer-vue.vue
 * @Description: 
 -->
<template>
  <div :id="config.id" :style="rootStyle" :ref="config.id"></div>
</template>

<script>
import Player from 'xgplayer'
import HlsPlayer from 'xgplayer-hls'
import FlvPlayer from 'xgplayer-flv'

export default {
  name: 'VueXgplayer',
  data: function () {
    return {
      player: null
    }
  },
  props: {
    config: {
      type: Object,
      default() {
        return { url: '', autoplay: true }
      }
    },
    rootStyle: {
      type: Object,
      default() {
        return {}
      }
    },
    playUrl: {
      type: String,
      default: ''
    }
  },
  watch: {
    playUrl: {
      immediate: true,
      handler(newUrl, oldUrl) {
        if (newUrl !== '' && oldUrl !== '' && (newUrl ?? false)) {
          // this.init()
        }
      }
    }
  },
  methods: {
    init() {
      let suffix = this.playUrl
        .split('.')
        .reverse()[0]
        .match(/^[^?]*/)[0]
      this.playUrl = this.playUrl.replace('http://', 'https://')
      if (this.playUrl && this.playUrl !== '') {
        let config = { ...this.config, ...{ url: this.playUrl } }
        if (suffix == 'mp4') {
          this.player = new Player(config)
        } else if (suffix == 'm3u8') {
          this.player = new HlsPlayer({ ...config, ...{} })
        } else if (suffix == 'flv') {
          this.player = new FlvPlayer({ ...config, ...{} })
        }
        this.$emit('player', this.player)
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeUpdate() {
    // this.init()
  },
  beforeDestroy() {
    this.player &&
      typeof this.player.destroy === 'function' &&
      this.player.destroy()
  }
}
</script>
